import { ITelemetryHandler } from "@ms/telemetry-manager/lib/ITelemetryHandler";
import { Manager } from "@ms/telemetry-manager";

import { IAnalyticsService } from "@msteams/bridges-models-ts-analytics";
import { FilesAnalyticsScenarios } from "@msteams/bridges-models-files";
import { AnalyticsService } from "@msteams/bridges-services-ts-analytics";
// OOO Circular: services/bridges-services-files-prefetch/src/files-prefetcher.ts > services/bridges-services-files-prefetch/src/items-view-configuration.ts > services/bridges-services-files-prefetch/src/services-files-telemetry/items-view-telemetry-handler-factory.ts > services/bridges-services-files-prefetch/src/services-files-telemetry/items-view-telemetry-handler.ts
import { ItemsViewTelemetryHandler } from "./items-view-telemetry-handler";

export class ItemsViewTelemetryHandlerFactory {
  private static itemsViewTelemetryHandlerInstance: ITelemetryHandler;
  private static analyticsService: IAnalyticsService<FilesAnalyticsScenarios>;
  private static createFolderAndRefreshSiteUrl?: (threadId: string) => void;

  // This is one time initialization which must happen before getting the instance of ItemsViewTelemetryHandler
  public static init(
    analyticsService: IAnalyticsService<FilesAnalyticsScenarios>,
    createFolderAndRefreshSiteUrl?: (threadId: string) => void
  ) {
    if (!ItemsViewTelemetryHandlerFactory.analyticsService) {
      ItemsViewTelemetryHandlerFactory.analyticsService = analyticsService;
      ItemsViewTelemetryHandlerFactory.createFolderAndRefreshSiteUrl = createFolderAndRefreshSiteUrl;
    }
  }

  public static getItemsViewTelemetryHandler(): ITelemetryHandler {
    if (!ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance) {
      if (!ItemsViewTelemetryHandlerFactory.analyticsService) {
        ItemsViewTelemetryHandlerFactory.init(
          new AnalyticsService<FilesAnalyticsScenarios>()
        );
      }
      ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance = new ItemsViewTelemetryHandler(
        ItemsViewTelemetryHandlerFactory.analyticsService,
        ItemsViewTelemetryHandlerFactory.createFolderAndRefreshSiteUrl
      );
      // attach global manager from item-scope once
      ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance.attach(
        Manager
      );
    }
    return ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance;
  }
}
